/**
 * Memberships — UI presentation settings (Phase 10D).
 *
 * Per ADR 0002 (three-bucket config), all business rules (min lengths, hard
 * limits) live on the server and are read via useMembershipsConfig().
 * Only pure display tunables live here.
 */

export const MEMBERSHIPS_LIST_PAGE_SIZE = 50;

export const DEFAULT_VISIBLE_COLUMNS = [
  'student_name',
  'package_name',
  'status',
  'next_invoice_date',
  'amount',
] as const;

export const PAUSE_REASON_PRESETS = [
  'Family travel',
  'Medical break',
  'School exams',
  'Other',
] as const;

export const CANCEL_REASON_PRESETS = [
  'Moved away',
  'Switched to different school',
  'Time conflict',
  'Financial',
  'Other',
] as const;

export const AUTOSAVE_DEBOUNCE_MS = 600;

export const RECURRENCE_PRESETS = [
  { label: 'Monthly', unit: 'month', interval: 1 },
  { label: 'Bi-monthly', unit: 'month', interval: 2 },
  { label: 'Quarterly', unit: 'month', interval: 3 },
  { label: 'Half-yearly', unit: 'month', interval: 6 },
  { label: 'Yearly', unit: 'year', interval: 1 },
] as const;
